import React from "react";
import "../CSS/ProfileExpandableSection.css";
import collapsedArrowIcon from "../../../assets/images/profile-collapsed-arrow-icon.svg";
import whatsappIcon from "../../../assets/images/profile-whatsapp-icon.svg";

interface ProfileNonExpandableSectionProps {
  title: string;
  subTitle: string;
  onClick: () => void;
}

const ProfileNonExpandableSection: React.FC<
  ProfileNonExpandableSectionProps
> = ({ title, subTitle, onClick }) => {
  const isChatSection = title.includes("Chat");
  return (
    <div style={{ marginBottom: "10px" }}>
      <div
        className="profile-screen-details-container"
        onClick={onClick}
        style={{ cursor: "pointer" }}
      >
        <span>
          {title} <span style={{ color: "#C2B58C" }}>{subTitle}</span>
        </span>
        {isChatSection ? (
          <img src={whatsappIcon} alt="whatsapp-icon" />
        ) : (
          <div className="profile-screen-details-expand-container">
            <img
              src={collapsedArrowIcon}
              alt="collapsed-arrow-icon"
              style={{
                transform: "rotate(270deg)",
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileNonExpandableSection;
